import { Editor, EditorContent } from "@tiptap/react";

import useAccessibilityControlsContext from "@/view/utils/useAccessibilityControlsContext";
import { getEditorContentWrapperStyles } from "./UnlevelledContentEditorContent.styles";

interface UnlevelledContentEditorContentProps {
  editor: Editor;
}

const UnlevelledContentEditorContent = ({
  editor,
}: UnlevelledContentEditorContentProps) => {
  const { currentFontSize } = useAccessibilityControlsContext();

  return (
    <div css={getEditorContentWrapperStyles(currentFontSize)}>
      <EditorContent editor={editor} />
    </div>
  );
};

export default UnlevelledContentEditorContent;
